import { render, staticRenderFns } from "./AuthSidebarPTSI.vue?vue&type=template&id=5cff15ec&scoped=true"
import script from "./AuthSidebarPTSI.vue?vue&type=script&lang=js"
export * from "./AuthSidebarPTSI.vue?vue&type=script&lang=js"
import style0 from "./AuthSidebarPTSI.vue?vue&type=style&index=0&id=5cff15ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff15ec",
  null
  
)

export default component.exports